import React from 'react'

export const Reports = () => {
  return (
    <div>reports</div>
  )
}
